
import React, { useState } from "react";
import { CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import CallLogsConsolidate from "./CallLogsConsolidate";
import ConsolidateNeverAttended from "./ConsolidateNeverAttended";
import ConsolidateNotPickedUp from "./ConsolidateNotPickedUp";
import UniqueClientConsolidated from "./UniqueClientConsolidated";
import ConnectedConsolidate from "./ConnectedConsolidate";

const ConsolidatedTable = ({
  selectedFromDate,
  selectedToDate,
  selectedEmployeeOptions,
  setSelectedFromDate,
  setSelectedToDate,
  appliedFilters,
  teamIndu,
  setTeamIndu, 
  selectedEmployeeOptions2
}) => {
  
  const [customActiveTab, setCustomActiveTab] = useState("1");

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
    }
  };

  // Ensure state is managed centrally and passed properly
  const commonProps = {
    selectedFromDate,
    selectedToDate,
    selectedEmployeeOptions,
    setSelectedFromDate,
    setSelectedToDate,
    appliedFilters,
    teamIndu,
    setTeamIndu,
    selectedEmployeeOptions2
  };

  const tabComponents = {
    "1": <CallLogsConsolidate {...commonProps} />,
    "2": <ConsolidateNotPickedUp {...commonProps} />,
    "3": <ConsolidateNeverAttended {...commonProps} />,
    "4": <UniqueClientConsolidated {...commonProps} />,
    "5": <ConnectedConsolidate {...commonProps} />,

  };

  return (
    <div className="sn-bulk-reportanal-tble sn-storage-tble-top w-100">
      <div className="sn-report-lead-tabs">
        <CardBody className="pt-0">

          <Nav tabs className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3">
            
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: customActiveTab === "1" })}
                onClick={() => toggleCustom("1")}
              >
                Call Logs Report
              </NavLink>
            </NavItem>

            <NavItem>
              
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: customActiveTab === "2" })}
                onClick={() => toggleCustom("2")}
              >
                Not Picked up by client
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: customActiveTab === "3" })}
                onClick={() => toggleCustom("3")}
              >
                Never Attended call
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: customActiveTab === "4" })}
                onClick={() => toggleCustom("4")}
              >
                Unique call
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: customActiveTab === "5" })}
                onClick={() => toggleCustom("5")}
              >
                Connected call
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={customActiveTab} className="text-muted">
            <TabPane tabId={customActiveTab}>
              <div className="d-flex">
                <div className="flex-grow-1 ms-2">
                  <div className="sn-lead-report-manavgment-tble-ui">
                    {tabComponents[customActiveTab]}
                  </div>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </CardBody>
      </div>
    </div>
  );
};

export default ConsolidatedTable;
